/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpContextToken,
  HttpEvent,
  HttpEventType,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { map, Observable } from 'rxjs'
import { APIEnvelope } from '../models/api'

export const PARSE_NUMBER_PROPS = new HttpContextToken<string[]>(() => [])

export class NumberInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(
      map((res) => {
        if (
          res.type !== HttpEventType.Response || // not even a response
          !res.ok || // error
          !res.body || // strange shape
          !(res.body as any).results || // strange shape
          !((res.body as any).results as any).length // no results to transform
        ) {
          // do nothing
          return res
        }

        return res.clone({
          body: {
            ...res.body,
            results: (res.body as APIEnvelope<any>).results.map((item) =>
              req.context.get(PARSE_NUMBER_PROPS).reduce(
                (acc, key) => ({
                  ...acc,
                  [key]: this.asNumber(acc[key]),
                }),
                item,
              ),
            ),
          } as APIEnvelope<any>,
        })
      }),
    )
  }

  asNumber(v: any) {
    if(typeof v === 'string') {
      return Number(v)
    }
    
    return v
  }
}
